

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'LazyImage',
})
export default class LazyImage extends Vue {
  @Prop({
    default: () => undefined,
  })
  public src!: string;
  @Prop({
    default: () => '1.7',
  })
  public aspectRatio!: string;
}
